export const demoPreview = {
  badgeLabel: 'Demo preview',
  shortBadgeLabel: 'Unofficial demo',
  shortMessage: 'We remove it on request.',
  bannerMessage:
    'Not the clinic’s official website. An unsolicited free concept by JMR Squared. We remove it on request.',
  attributionContext:
    'Not the clinic’s official website. An unsolicited free concept by JMR Squared showing what a dedicated website could do for this clinic, not affiliated with or endorsed by the business. We remove it on request.',
} as const;
